/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Submit_Autofill_SourcesInputs */

const en_directory_submit_autofill_sources = /** @type {(inputs: Directory_Submit_Autofill_SourcesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Used ${i?.count} source pages. Review the result before submitting.`)
};

const zh_directory_submit_autofill_sources = /** @type {(inputs: Directory_Submit_Autofill_SourcesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`使用了 ${i?.count} 个来源页面，请在提交前检查结果。`)
};

/**
* | output |
* | --- |
* | "Used {count} source pages. Review the result before submitting." |
*
* @param {Directory_Submit_Autofill_SourcesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_autofill_sources = /** @type {((inputs: Directory_Submit_Autofill_SourcesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Autofill_SourcesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_autofill_sources(inputs)
	return zh_directory_submit_autofill_sources(inputs)
});
export { directory_submit_autofill_sources as "directory.submit.autofill_sources" }